import StockSearchItemBase from "@/classes/stock/StockSearchItemBase";

export default class SkuHistorySearch extends StockSearchItemBase {
    constructor() {
        super();

        this.jobNumber = '';
        this.dateFrom = '';
        this.dateTo = '';
    }

}
